/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Edit_Display_Name_LabelInputs */

const es_user_profile_edit_display_name_label = /** @type {(inputs: User_Profile_Edit_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre visible`)
};

const en_user_profile_edit_display_name_label = /** @type {(inputs: User_Profile_Edit_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display name`)
};

/**
* | output |
* | --- |
* | "Display name" |
*
* @param {User_Profile_Edit_Display_Name_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_edit_display_name_label = /** @type {((inputs?: User_Profile_Edit_Display_Name_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Edit_Display_Name_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_edit_display_name_label(inputs)
	return en_user_profile_edit_display_name_label(inputs)
});
export { user_profile_edit_display_name_label as "user.profile.edit.display_name_label" }